module.exports = __webpack_public_path__ + "static/img/voice3_right.cf3042ed.png";